<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="admin-icon">
          <span class="material-symbols-outlined">admin_panel_settings</span>
        </div>
        <h1>Panel de Administración</h1>
        <!--   <p>Acceso exclusivo para administradores del blog</p> -->
      </div>

      <form @submit.prevent="handleSubmit" class="login-form">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            v-model="email"
            required
            placeholder="tu@email.com"
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <input
            type="password"
            id="password"
            v-model="password"
            required
            placeholder="Tu contraseña"
            class="form-input"
          />
        </div>

        <div v-if="error" class="error-message">
          {{ error }}
        </div>

        <div v-if="redirectedFromAdmin" class="info-message">
          <span class="material-symbols-outlined">info</span>
          <p>Debes iniciar sesión para acceder al panel de administración</p>
        </div>

        <button type="submit" class="btn-submit" :disabled="loading">
          <span v-if="loading">Accediendo al panel...</span>
          <span v-else>Acceder al Panel</span>
        </button>
      </form>

      <div class="login-footer">
        <div class="admin-notice">
          <span class="material-symbols-outlined">security</span>
          <p>Acceso restringido solo para administradores autorizados</p>
        </div>
        <button @click="goBack" class="link-button">Volver al sitio web</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { supabase } from '../lib/supabase'

const router = useRouter()

const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const redirectedFromAdmin = ref(false)

// Verificar si ya está logueado al cargar el componente
onMounted(async () => {
  try {
    // Verificar si fue redirigido desde una ruta protegida
    const fromRoute = router.currentRoute.value.query.from
    if (fromRoute === 'admin') {
      redirectedFromAdmin.value = true
    }

    const {
      data: { session },
    } = await supabase.auth.getSession()
    if (session && session.user) {
      // Si ya está logueado, redirigir al panel de administración
      console.log('Usuario ya autenticado, redirigiendo al panel admin')
      router.push('/admin')
    }
  } catch (error) {
    console.error('Error al verificar sesión:', error)
  }
})
const handleSubmit = async () => {
  loading.value = true
  error.value = ''

  try {
    // Login de administrador
    console.log('Intentando login de administrador con:', {
      email: email.value,
      password: '***',
    })

    const { data, error: authError } = await supabase.auth.signInWithPassword({
      email: email.value,
      password: password.value,
    })

    if (authError) {
      console.error('Error de login:', authError)
      error.value = `Error: ${authError.message} (Código: ${authError.status})`
    } else {
      console.log('Login exitoso:', data)
      // Redirigir al panel de admin
      router.push('/admin')
    }
  } catch (err) {
    error.value = 'Error inesperado. Intenta de nuevo.'
    console.error('Error de autenticación:', err)
  } finally {
    loading.value = false
  }
}

const goBack = () => {
  router.push('/')
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 20px;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.admin-icon {
  margin-bottom: 20px;
}

.admin-icon .material-symbols-outlined {
  font-size: 48px;
  color: #1297ef;
  background: linear-gradient(45deg, #1297ef, #4ab7ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login-header h1 {
  color: #333;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.login-header p {
  color: #666;
  font-size: 16px;
}

.login-form {
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
  font-size: 14px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 10px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
}

.form-input:focus {
  outline: none;
  border-color: #1297ef;
  box-shadow: 0 0 0 3px rgba(18, 151, 239, 0.1);
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid #fcc;
}

.info-message {
  background: #e8f4fd;
  color: #0c5460;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid #bee5eb;
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-message .material-symbols-outlined {
  color: #1297ef;
  font-size: 18px;
}

.info-message p {
  margin: 0;
  font-weight: 500;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background: linear-gradient(45deg, #1e3c72, #2a5298);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(30, 60, 114, 0.4);
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-footer {
  text-align: center;
  border-top: 1px solid #e1e5e9;
  padding-top: 20px;
}

.admin-notice {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(18, 151, 239, 0.1);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid rgba(18, 151, 239, 0.2);
}

.admin-notice .material-symbols-outlined {
  color: #1297ef;
  font-size: 20px;
}

.admin-notice p {
  color: #333;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.login-footer p {
  color: #666;
  font-size: 14px;
  /* margin-bottom: 15px; */
  text-align: start;
}

.link-button {
  background: none;
  border: none;
  color: #1297ef;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.link-button:hover {
  color: #1e3c72;
}

@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
  }

  .login-header h1 {
    font-size: 24px;
  }

  .form-input {
    font-size: 16px; /* Evita zoom en iOS */
  }
}
</style>
